var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useRoute } from 'ziggy-js';
import Button from '@/Jetstream/Button';
import handleUnsavedChanges from '../../../Utils/handleUnsavedChanges';
import useForm from '@/Utils/useForm';
import StepLayout from "./StepLayout";
import TravelStepFields from './Partials/TravelStepFields';
import { Ziggy } from "@/ziggy";
export default function TravelStep(_a) {
    var certificate = _a.certificate, team = _a.team, branch = _a.branch, countryOptions = _a.countryOptions, languageOptions = _a.languageOptions;
    var route = useRoute(Ziggy);
    var init = __assign(__assign({}, certificate), { transporter: certificate.transporter || 'owner', _step: 2 });
    var form = useForm(init);
    handleUnsavedChanges(form);
    function submit() {
        form.put(route('team.branch.certificate.update', { team: team, branch: branch, certificate: certificate }), {
            preserveScroll: true,
        });
    }
    useEffect(function () {
    });
    return (_jsxs(StepLayout, __assign({ team: team, branch: branch, certificate: certificate, form: form }, { children: [_jsx("div", __assign({ className: "flex-1 flex flex-col" }, { children: _jsx("div", __assign({ className: "divide-y divide-gray-200" }, { children: _jsx("div", __assign({ className: "space-y-6" }, { children: _jsx(TravelStepFields, { form: form, countryOptions: countryOptions, languageOptions: languageOptions }) })) })) })), _jsx(Button, __assign({ id: "continue", disabled: form.processing, onClick: submit, className: "mt-6" }, { children: "Save & continue" }))] })));
}
